import { ApiObj } from './api.type'
import { getProductionApi } from './production-api'

export function getApi(): ApiObj {
  return getProductionApi()
  // return getMockApi()
  // return getCustomApi()
}
